import * as React from 'react';

const LegalAge = () => (
  <div className="col-xs-12" style={{ padding: '1rem' }}>
    <p className="text-left" style={{ fontSize: '.8rem' }}>
      Du må være minst 18 år for å kjøpe abonnement. Vi bruker denne
      informajonen til å forbedre tjenesten vår og gi deg relevante tilbud og
      informasjon. &nbsp;
      <a href="https://info.privacy.schibsted.com/no/S007">
        Du kan justere dine personvernsinnstillinger når som helst
      </a>
      &nbsp;eller&nbsp;
      <a href="https://info.privacy.schibsted.com/no/S012">
        les mer om dine brukerdata.
      </a>
    </p>
  </div>
);

export default LegalAge;



// WEBPACK FOOTER //
// ./src/gdpr/LegalAge.tsx